<template>
  <div class="app">
    <img
      src="../../../assets/allImage/manpowerResource/toutu_renliziyuan@1x.png"
      alt=""
    />
    <div class="app-content">
      <div class="item_son">
        <div class="obj_box" v-for="item in list" :key="item.id">
          <img
            class="srcImg"
            src="../../../assets/allImage/companyProfile/wenzitubiao@2x.png"
            alt=""
          />
          <div class="title_sk">
            {{ item.title }}
          </div>
          <div class="content_sk">
            <div>{{ item.time }}</div>
            <div class="vd_ds">查看详情></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <!-- <div class="pagination_block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination>
    </div> -->
    <BottomField></BottomField>
  </div>
</template>

<script>
import BottomField from '@/layout/components/HomePage/BottomField/index.vue';
export default {
  components: {
    BottomField,
  },
  data() {
    return {
      currentPage4: 4,
      imageSize: 'cover',
      list: [
        {
          id: 0,
          title: '广西捷通高速科技有限公司2016年度招聘公告',
          time: '2023-01-01',
        },
      ],
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.app {
  width: 100%;
  background-color: #f5f5f5;
  .app-content {
    width: 100%;
    display: flex;
    justify-content: center;

    .item_son {
      width: 80%;
      padding: 0 5rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 0.9375rem;
      .obj_box {
        width: 31.25rem;
        height: 7.5rem;
        border-radius: 0.25rem;
        padding: 0.9375rem;
        margin-top: 0.9375rem;
        background-color: #fff;
        position: relative;
        .srcImg {
          width: 1.25rem;
          position: absolute;
          left: 0;
          top: 0;
        }
        .title_sk {
          width: 100%;
          height: 2.1875rem;
          margin-top: 0.625rem;
          font-weight: 600;
          font-size: 0.875rem;
          line-height: 2.1875rem;
          text-align: left;
        }
        .content_sk {
          width: 100%;
          height: 2.1875rem;
          margin-top: 0.625rem;
          font-size: 0.75rem;
          line-height: 2.1875rem;
          border-top: 0.0625rem dashed #b9b7b7;
          display: flex;
          justify-content: space-between;
          .vd_ds {
            color: #0aa4ee;
          }
        }
      }
    }
  }
  .pagination_block {
    width: 80%;
    height: 3.125rem;
    margin: 0 auto;
    text-align: right;
    padding-right: 5rem;
  }
}
</style>
